import { action, observable } from 'mobx';

export const MARKETING_SOURCE = 'source';
export const MARKETING_AFFILIATE_ID = 'affiliateId';

export class MarketingStore {
  @observable accessor source: string =
    sessionStorage.getItem(MARKETING_SOURCE) || '';
  @observable accessor affiliateId: string =
    sessionStorage.getItem(MARKETING_AFFILIATE_ID) || '';

  @action
  setSource(source: string) {
    this.source = source;
    sessionStorage.setItem(MARKETING_SOURCE, source);
  }

  @action
  setAffiliateId(affiliateId: string) {
    this.affiliateId = affiliateId;
    sessionStorage.setItem(MARKETING_AFFILIATE_ID, affiliateId);
  }

  @action
  setMarketingParams(params: { source?: string; affiliateId?: string }) {
    if (params.source) {
      this.setSource(params.source);
    }
    if (params.affiliateId) {
      this.setAffiliateId(params.affiliateId);
    }
  }

  @action
  clearMarketingParams() {
    this.source = '';
    this.affiliateId = '';
    sessionStorage.removeItem(MARKETING_SOURCE);
    sessionStorage.removeItem(MARKETING_AFFILIATE_ID);
  }
}

const marketing = new MarketingStore();

export default marketing;
